import { useCallback, useLayoutEffect, useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useGetOtherProfile } from '../../../../../hooks/queries/profile/use-get-other-profile'
import { useGlobalStore } from '../../../../../store/global-store'
import type { LiveGuest, User } from '../../../../../types/lives/live'
import { useGetDataSeats } from './use-get-data-seats'

export interface HostUserToGift {
  user: User
  userId: number
  position: number
}

export const useGetUsersToGift = () => {
  const { liveId, liveUserId, typeLive, userIdToSendGift } = useGlobalStore(
    useShallow((state) => ({
      // live: state.live,
      liveId: state.liveId,
      liveUserId: state.liveUserId,
      typeLive: state.typeLive,
      usersToGift: state.usersToGift,
      userIdToSendGift: state.userIdToSendGift,
      // modalGiftOpen: state.modalGiftOpen.visible,
    })),
  )

  const { user: userToSendGift } = useGetOtherProfile(
    userIdToSendGift as number,
  )

  const { user: liveUser } = useGetOtherProfile(liveUserId as number)
  const { formatedDataSeats } = useGetDataSeats()

  const keyExtractor = useCallback((item: LiveGuest) => `${item.position}`, [])

  const handleSelectUserToGift = useCallback((id: number) => {
    if (typeof id !== 'number') {
      return console.error(id, 'is not a number')
    }

    const usersToGift = useGlobalStore.getState().usersToGift

    if (usersToGift?.has(id)) {
      return useGlobalStore.setState((state) => {
        const newSet = new Set(state?.usersToGift)
        newSet.delete(id)

        return { usersToGift: newSet }
      })
    }

    return useGlobalStore.setState((state) => {
      const newSet = new Set(state.usersToGift)
      newSet.add(id)

      return { usersToGift: newSet }
    })
  }, [])

  useLayoutEffect(() => {
    if (liveUserId && !userIdToSendGift) {
      handleSelectUserToGift(liveUserId)
    }

    if (Boolean(userIdToSendGift) && typeof userIdToSendGift === 'number') {
      handleSelectUserToGift(userIdToSendGift)
    }
  }, [liveUserId, userIdToSendGift, handleSelectUserToGift])

  const checkGifters = useMemo(() => {
    const isAudioModel = typeLive?.includes('multi')

    const dataOnlyStreamer: HostUserToGift = {
      user: liveUser as User,
      userId: liveUserId!,
      position: 0,
    }

    const usersAllowedsToGift = [dataOnlyStreamer]

    if (!isAudioModel && userIdToSendGift) {
      usersAllowedsToGift.push({
        user: userToSendGift as User,
        userId: userIdToSendGift,
        position: 2,
      })
    }

    if (liveId) {
      return isAudioModel ? formatedDataSeats : usersAllowedsToGift
    }

    if (!liveId) {
      return []
    }
  }, [
    liveUser,
    liveId,
    liveUserId,
    userIdToSendGift,
    userToSendGift,
    formatedDataSeats,
    typeLive,
  ])

  return {
    // live,
    typeLive,
    checkGifters,
    handleSelectUserToGift,
    keyExtractor,
  }
}
